














import { Component, Prop, Vue } from 'vue-property-decorator';
import firebase, { firestore } from "firebase";
const provider = new firebase.auth.GoogleAuthProvider()

@Component({
})
export default class Authorize extends Vue {
  @Prop() authorized!: boolean
  authparam: {
    id: string
    password: string
  } = {
    id: "",
    password: "",
  }

  private authorizing = false

  get cu() { return firebase.auth().currentUser }
  get trimmed_authparam() {
    const { id, password } = this.authparam
    const r = {
      id: (id || "").trim(),
      password: (password || "").trim(),
    }
    return (r.id && r.password) ? r : undefined
  }

  async go_auth() {
    if (this.authorizing) { return }
    if (!this.trimmed_authparam) { return }
    try {
      this.authorizing = true
      const { id, password } = this.trimmed_authparam
      const cred = await firebase.auth().signInWithEmailAndPassword(id, password)
      if (!cred.user) {
        throw { message: "authorization failed" }
      }
      this.$emit("snackon", { text: "authorization ok" })
    } catch(e) {
      console.error(e)
      this.$emit("snackon", { text: "authorization failed", color: "red info" })
    }
    this.authorizing = false
  }

  mounted() {
  }
}
